import { render, staticRenderFns } from "./MshipsversionGrid.vue?vue&type=template&id=971e08ec"
import script from "./MshipsversionGrid.vue?vue&type=script&lang=js"
export * from "./MshipsversionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports